import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import Icon from 'flarum/common/components/Icon';
import SubtreeRetainer from 'flarum/common/utils/SubtreeRetainer';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
export default class Backers extends Component {
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    if (!this.attrs.discussion.backers()) {
      this.load();
    }
    this.subtreeRetainer = new SubtreeRetainer(() => this.loading, () => this.attrs.discussion.backers());
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    return this.subtreeRetainer.needsRebuild();
  }
  view() {
    return m("div", {
      className: "Payments-backers"
    }, m("div", {
      className: "Payments-backers-container"
    }, this.loading ? m(LoadingIndicator, null) : this.content()));
  }
  content() {
    const backers = this.attrs.discussion.backers() || [];
    return m('[', null, m("div", {
      className: "Payments-backers-header"
    }, this.headerItems(backers).toArray()), m("div", {
      className: "Payments-backers-body"
    }, backers.length === 0 ? m("div", {
      className: "Payments-backers-body-message"
    }, app.translator.trans('floxum-payments.forum.backers-widget.none')) : this.backersView(backers)));
  }
  headerItems(backers) {
    const items = new ItemList();
    items.add('totalBounty', this.headerItemView(this.attrs.discussion.bountyCurrencySymbol(), this.attrs.discussion.totalBounty(), extractText(app.translator.trans('floxum-payments.forum.backers-widget.pledged'))));
    items.add('backerCount', this.headerItemView(m(Icon, {
      name: "fas fa-hand-holding-heart"
    }), backers.length, extractText(app.translator.trans('floxum-payments.forum.backers-widget.backers'))));
    return items;
  }
  headerItemView(icon, value, label) {
    return m("div", {
      className: "Payments-backers-info"
    }, m("div", {
      className: "Payments-backers-info-value"
    }, m("span", {
      className: "Payments-backers-info-icon"
    }, icon), m("span", {
      className: "Payments-backers-info-number"
    }, value)), m("div", {
      className: "Payments-backers-info-label"
    }, label));
  }
  backersView(backers) {
    const max = 15;
    return m("div", {
      className: "Payments-backers-users"
    }, backers.slice(0, max).map(user => m(Link, {
      href: app.route('user', {
        username: user.slug()
      }),
      className: "Payments-backers-users-item"
    }, m(Tooltip, {
      content: user.displayName()
    }, m(Avatar, {
      user: user
    })))), backers.length > max ? m("span", {
      className: "Payments-backers-users-item Payments-backers-users-item--plus"
    }, m("span", {
      className: "Avatar"
    }, `+${backers.length - max}`)) : null);
  }
  async load() {
    this.loading = true;
    this.attrs.discussion = await app.store.find('discussions', this.attrs.discussion.id(), {
      include: 'backers'
    });
    this.loading = false;
    m.redraw();
  }
}
flarum.reg.add('floxum-payments', 'forum/Discussion/Backers', Backers);